import { RightOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import { Translate } from "../i18n";
import { Person } from "../model/person";

/**
 * The four columns every people table shows.
 *
 * They were repeated verbatim in the list, the assignment picker and both
 * record editors. Now that the headings come from the catalogue they are
 * defined once, so a heading cannot end up translated on one screen and not on
 * another.
 *
 * `drill` adds the trailing chevron the list pages use to signal that a row
 * opens; the pickers, whose rows carry checkboxes instead, leave it out.
 */
export function personColumns(t: Translate, options?: { drill?: boolean }): ColumnsType<Person> {
    const columns: ColumnsType<Person> = [
        {
            title: t("person.column.firstName"),
            dataIndex: "firstName",
            key: "firstName",
            sorter: (a, b) => (a.firstName > b.firstName ? -1 : 1)
        },
        {
            title: t("person.column.lastName"),
            dataIndex: "lastName",
            key: "lastName",
            sorter: (a, b) => (a.lastName > b.lastName ? -1 : 1)
        },
        {
            title: t("person.column.phone"),
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            sorter: (a, b) => (a.phoneNumber > b.phoneNumber ? -1 : 1),
            render: (phoneNumber: string) => <span className="cell-mono">{phoneNumber}</span>
        },
        {
            title: t("person.column.email"),
            dataIndex: "email",
            key: "email",
            sorter: (a, b) => (a.email > b.email ? -1 : 1)
        }
    ];

    if (options?.drill === true) {
        columns.push({
            key: "drill",
            width: 52,
            align: "right",
            render: () => (
                <span className="row-drill">
                    <RightOutlined />
                </span>
            )
        });
    }

    return columns;
}
